import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AppointmentStatus } from 'src/app/modules/booking/models/appointment.enum'
import { Subscription } from 'rxjs'
import { Router } from '@angular/router'

@Component({
	selector: 'app-client-profile-table',
	templateUrl: './client-profile-table.component.html',
	styleUrls: ['./client-profile-table.component.scss'],
})
export class ClientProfileTableComponent implements OnInit, OnChanges {
	@Input() selectedCountry!: number
	@Input() tableDetails: any
	@Input() clientProfileTableDetails: any
	@Input() totalCount!: number
	noDataFoundMessage: string = 'CLIENT.CLIENT_DETAILS.NO_BOOKING_FOUND'
	appointmentStatus = AppointmentStatus
	subscription = new Subscription()
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()

	constructor(public translate: TranslateService, private router: Router) {}

	ngOnInit(): void {}
	handelUtcToLocal(time: any) {
		if (time?.length) {
			let newtime = new Date()
			newtime.setHours(
				time.split(':')[0] > 12 ? time.split(':')[0] - 12 : time.split(':')[0]
			)
			newtime.setMinutes(time.split(':')[1]?.split(' ')[0])
			return (
				newtime.toTimeString().split(' ')[0] +
				(time.split(':')[0] >= 12
					? this.translate.currentLang == 'en'
						? 'PM'
						: 'م'
					: this.translate.currentLang == 'en'
					? 'AM'
					: 'ص')
			)
		}
		return ''
	}
	navigation(id: number) {
		this.router.navigate([`/layout/booking/booking-details/${id}`])
	}
	ngOnChanges(changes: SimpleChanges): void {}
}
